var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_vm._t("default"),(_vm.name && _vm.canClose)?_c('div',{staticClass:"close"},[_c('button',{staticClass:"unbutton",attrs:{"type":"button"},on:{"click":function($event){return _vm.$modal.hide(_vm.name)}}},[_c('svg-close')],1)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }